import * as React from 'react';
import { FormattedMessage } from 'react-intl';
import HistorySection from 'Components/HistorySection';
import { sortPartialDate } from 'neuro-utils';
import { mergeDocuments } from '../../utils';
import { rowData, TPulmonaryRowDataKey } from '../Form/Pulmonary/rowData';
import { History, TPulmonaryWithPreviousDates } from './Components/History';
import DocumentCreationButton from 'Components/DocumentCreationButton';

const Pulmonary = ({ documents, startEdit }: IOwnProps): React.JSX.Element => {
  return (
    <HistorySection
      headerText={<FormattedMessage id={'pulmonary.airwayClearanceorSecretionMobilisation'} />}
      newButton={
        <DocumentCreationButton
          name="pulmonary"
          text={'pulmonary.newDocument'}
          onClick={startEdit({}, 'pulmonary')}
          width={15}
          height={3}
          fontSize={14}
          alternate={true}
        />
      }
      hasHistoryRows={true}
    >
      <React.Fragment>
        {documents
          .toSorted((n1, n2) => sortPartialDate(n2.date, n1.date) || n2._cdate - n1._cdate)
          .map((d, index) => {
            const historyDocument = d === documents[0] && documents.length > 1 ? mergeDocuments(documents) : d;
            return (
              <React.Fragment key={d._id}>
                <History
                  d={historyDocument as TPulmonaryWithPreviousDates}
                  startEdit={startEdit}
                  rows={
                    Object.keys(rowData).filter(key => {
                      return key !== 'assistanceInAirwayClearanceorSecretionMobilisation' &&
                        (d as { [key: string]: any })['assistanceInAirwayClearanceorSecretionMobilisation'] !== 'yes'
                        ? false
                        : key === 'ippvHoursPerDay' &&
                            (((d as { [key: string]: any })['ippv'] &&
                              (d as { [key: string]: any })['ippv'] !== 'daily') ||
                              !documents.find(d => (d as { [key: string]: any })['ippv'] === 'daily'))
                          ? false
                          : key === 'otherAssistance' &&
                              (((d as { [key: string]: any })['other'] &&
                                (d as { [key: string]: any })['other'] == 'no') ||
                                !documents.find(d =>
                                  ['daily', 'onDemand'].includes((d as { [key: string]: any })['other']),
                                ))
                            ? false
                            : true;
                    }) as Array<TPulmonaryRowDataKey>
                  }
                  index={index}
                />
              </React.Fragment>
            );
          })}
      </React.Fragment>
    </HistorySection>
  );
};

interface IOwnProps {
  documents: IDocumentWithTypeV2<'pulmonary'>[];
  startEdit: StartEdit;
}

export default Pulmonary;
